import { SVGProps } from 'react';

const SignpostBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 9H4L2 7l2-2h6m4 0h6l2 2-2 2h-6m-4 13V4a2 2 0 1 1 4 0v18m-6 0h8"
    />
  </svg>
);
export default SignpostBig;
